export const MIN_CONTENT_WIDTH = '455px';
export const MAX_CONTENT_WIDTH = '1280px';
